import { useState, FunctionComponent } from 'react';

// components
import Contact1stdibsModal from '../../contact1stdibs/Contact1stdibsModal';

// helpers
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';

type Props = {
    trackingLabel: string;
    serverRenderedChildren: string;
};

const Contact1stdibsFooterLinkWrapper: FunctionComponent<Props> = ({
    trackingLabel,
    serverRenderedChildren,
}) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions*/}
            <span
                onClick={event => {
                    setIsContactModalOpen(true);
                    trackFooterNavigationClick({ label: trackingLabel }, event);
                }}
            >
                {serverRenderedChildren}
            </span>
            <Contact1stdibsModal
                isOpen={isContactModalOpen}
                placement="globalFooter"
                onClose={() => setIsContactModalOpen(false)}
            />
        </>
    );
};

export default Contact1stdibsFooterLinkWrapper;
